/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "8573289b687da1213ad68a997c84cba1f77363db";
